
import { Component, Inject, Vue } from "vue-property-decorator";
import Loader from "../components/Loader.vue";
import { Container } from "inversify";
import { StatisticsStore } from "../../stores/organization/StatisticsStore";
import { handleError } from "../../../../common/src/utility/errorUtils";
import { OrganizationListStore } from "../../stores/organization/OrganizationListStore";

@Component({
    components: { Loader },
})
export default class StatisticsContainer extends Vue {
    @Inject("container") readonly container!: Container;
    statisticStore: StatisticsStore = this.container.get(StatisticsStore);
    organizationListStore: OrganizationListStore = this.container.get(OrganizationListStore);

    created() {
        this.statisticStore.load().catch(handleError);
    }

    get organizationUSGCount(): number {
        return this.organizationListStore.filteredItems.filter(
            (organization) => organization.duns && organization.ufFederalCage,
        ).length;
    }

    get organizationCount(): number | undefined {
        return this.statisticStore.item?.organizationCount;
    }

    get newOrganizationCount(): number | undefined {
        return this.statisticStore.item?.newOrganizationCount;
    }

    get countriesCount(): number | undefined {
        return this.statisticStore.item?.countriesCount;
    }

    get organizationTier1Count(): number | undefined {
        return this.statisticStore.item?.organizationTier1Count;
    }

    get organizationTier2Count(): number | undefined {
        return this.statisticStore.item?.organizationTier2Count;
    }

    get organizationTier3Count(): number | undefined {
        return this.statisticStore.item?.organizationTier3Count;
    }
}
